import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { PropostaEditarService } from '@app/api/propostas/proposta-editar.service';
import { isPropostaEmEdicao } from '@app/api/propostas/proposta-editar.models';
import { catchError, map, of } from 'rxjs';

export const PropostaStatusGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const propostaService = inject(PropostaEditarService);

  const propostaId = Number(route.params['id']);
  const organizacao =
    route.params['organizacao'] ||
    route.parent?.params?.['organizacao'] ||
    state.url.split('/')[1] ||
    '';

  if (!propostaId || Number.isNaN(propostaId)) {
    return of(
      router.createUrlTree([`/${organizacao}/auth/sign-in`], {
        queryParams: { message: 'Esta proposta já foi processada' },
      })
    );
  }

  return propostaService.getPropostaStatus(propostaId).pipe(
    map((response) => {
      if (
        !isPropostaEmEdicao(
          response?.data?.CodigoPropostaSituacao,
          response?.data?.CodigoPropostaSubSituacao
        )
      ) {
        return router.createUrlTree([`/${organizacao}/auth/sign-in`], {
          queryParams: {
            message: 'Esta proposta já foi processada',
            returnUrl: state.url,
          },
        });
      }

      return true;
    }),
    catchError(() =>
      of(
        router.createUrlTree([`/${organizacao}/auth/sign-in`], {
          queryParams: {
            message: 'Esta proposta já foi processada',
            returnUrl: state.url,
          },
        })
      )
    )
  );
};
